var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoElectricalConnection = function SvgNoElectricalConnection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0009 11.99V6.5C16.0009 5.5 14.9909 4.49 14.0009 4.5V0.5H12.0009V4.5H8.00094V0.5H6.00094V2.98L15.5109 12.48L16.0009 11.99ZM14.2409 13.76L5.20094 4.7L5.19094 4.71L1.98094 1.5L0.710938 2.75L4.07094 6.11C4.04094 6.24 4.00094 6.37 4.00094 6.5V11.98L7.50094 15.5V18.5H12.5009V15.5L12.9809 15.02L17.4509 19.5L18.7109 18.22L14.2409 13.76Z",
    fill: "currentColor"
  })));
};
export default SvgNoElectricalConnection;